module.exports = __webpack_public_path__ + "media/12_37.50ea1496.wav";